import { FRANCHISEE_NAME } from "../../constants/ActionTypes";

const INIT_STATE = {
    franchiseeName: {}
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FRANCHISEE_NAME: {

            return { ...state, franchiseeName: action.payload };
        }
        default:
            return state;
    }
}